<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="primary"
        pill
        @click="createCountry"
        v-if="hasPermission('create_country')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Create</span>
      </b-button>
    </div>
    <b-card>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="countries"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_country')"
        :per-page="0"
      >
        <template #cell(manage)="row">
          <b-button
            variant="info"
            pill
            size="sm"
            class="mr-50"
            @click="editCountry(row.item)"
            v-if="hasPermission('update_country')"
          >
            Edit
          </b-button>
          <b-button
            variant="danger"
            pill
            size="sm"
            @click="removeCountry(row.item)"
            v-if="hasPermission('delete_country')"
          >
            Delete
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateCountryModal
      @modalClosed="onModalClosed"
      :key="`create-${createCountryModalCount}`"
    />
    <EditCountryModal
      :country="country"
      @modalClosed="onModalClosed"
      :key="`edit-${editCountryModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CreateCountryModal from "@/components/country/CreateCountryModal.vue";
import EditCountryModal from "@/components/country/EditCountryModal.vue";
import util from "@/util.js";

export default {
  components: {
    CreateCountryModal,
    EditCountryModal,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "code", label: "Code" },
        { key: "created_at", label: "Created At" },
        { key: "updated_at", label: "Updated At" },
        { key: "manage", label: "Manage" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      countries: [],
      country: null,
      createCountryModalCount: 0,
      editCountryModalCount: 0,
    };
  },
  mixins: [util],
  async mounted() {
    await this.fetchPaginatedData();
  },
  methods: {
    ...mapActions({
      getCountries: "appData/getCountries",
      deleteCountry: "appData/deleteCountry",
    }),
    async fetchPaginatedData() {
      try {
        const res = await this.getCountries({
          pageNumber: this.currentPage,
        });
        this.countries = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createCountry() {
      this.createCountryModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-country-modal");
      });
    },
    editCountry(country) {
      this.country = country;
      this.editCountryModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-country-modal");
      });
    },
    async removeCountry(country) {
      this.country = country;
      try {
        const res = await this.deleteCountry({
          pk: this.country.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Country deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
